<template>
  <v-row row wrap>
    <v-col cols="12">
      <v-row justify="space-between">
        <v-col cols="12" sm="6" md="8">
          <!-- FILTERS HERE -->
          <v-row>
            <v-col cols="12" sm="4">
              <estado-convenio-combobox v-model="filters[0].value" @input="fetch" @change="fetch"
                                        clearable multiple></estado-convenio-combobox>
              <!--              <v-select v-model="filters[0].value"-->
              <!--                        :items="[{text: 'Vigente', value:true}, {text: 'Vencido', value:false}]"-->
              <!--                        label="Estado" @change="fetch" clearable-->
              <!--              />-->
            </v-col>
            <v-col cols="12" md="2" class="pt-8">
              <field-selector :fields="fields" v-model="fieldsSelected"></field-selector>
            </v-col>
          </v-row>

        </v-col>
        <v-col cols="12" sm="6" md="4" class="text-right">
          <v-menu absolute right top offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="green white--text"
                v-bind="attrs"
                v-on="on"
              >
                EXPORTAR
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportarCaidaDeCuotas">
                <v-list-item-title>Exportar Caída de Cuotas</v-list-item-title>
              </v-list-item>
              <v-list-item @click="exportarConvenio">
                <v-list-item-title>Exportar Convenio</v-list-item-title>
              </v-list-item>

            </v-list>
          </v-menu>
          <search-input @search="performSearch" v-model="search"/>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">

      <v-data-table
          class="mt-3"
          :headers="headersSelected"
          :items="items"
          :search="search"
          :single-expand="false"
          :server-items-length="totalItems"
          :loading="loading"
          :page.sync="pageNumber"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="orderBy"
          :sort-desc.sync="orderDesc"
          :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
          @update:page="fetch"
          @update:sort-by="fetch"
          @update:sort-desc="fetch"
          @update:items-per-page="fetch"
      >

        <template v-slot:item.createdAt="{ item }">
          {{ getDateFormat(item.createdAt) }}
        </template>

        <template v-slot:item.estado="{ item }">
         <v-chip :color="colorEstado(item.estado)">{{item.estado}}</v-chip>
        </template>

        <template v-slot:item.fechaInactivacion="{ item }">
          {{ getDateFormat(item.fechaInactivacion) }}
        </template>

        <template v-slot:item.montoTotal="{ item }">
          {{ currency }} {{ item.montoTotal.toLocaleString('es-AR') }}
        </template>

        <template v-slot:item.montoCuota="{ item }">
          {{ currency }} {{ item.montoCuota.toLocaleString('es-AR') }}
        </template>

        <template v-slot:item.metricas.montoCobrado="{ item }">
          {{ currency }} {{ item.metricas.montoCobrado.toLocaleString('es-AR') }}
        </template>

        <template v-slot:item.metricas.montoFaltante="{ item }">
          {{ currency }} {{ item.metricas.montoFaltante.toLocaleString('es-AR') }}
        </template>

        <template v-slot:item.metricas.montoVencido="{ item }">
          {{ currency }} {{ item.metricas.montoVencido.toLocaleString('es-AR') }}
        </template>

        <template v-slot:item.metricas.porcentajeVencido="{ item }">
          {{ item.metricas.porcentajeVencido.toLocaleString('es-AR') }} %
        </template>


        <template v-slot:item.deudas="{ item }">
          {{ item.deudas.length }}
        </template>

        <template v-slot:item.agencia="{ item }">
          {{ item.agencia.nombre }}
        </template>


        <template v-slot:item.cobranzas="{ item }">
          {{ item.cobranzas.length }}
        </template>

        <template v-slot:item.fueraDePauta="{ item }">
          {{ item.fueraDePauta ? 'Si' : 'No' }}
        </template>

        <template v-slot:item.quitaEspecial="{ item }">
          {{ item.quitaEspecial ? 'Si' : 'No' }}
        </template>

        <template v-slot:item.vigente="{ item }">
          <v-icon
              small
              :color="item.vigente? 'green' : (esReactivable(item) ? 'orange' : 'red' )"
              class="mx-1"
              @click="presentarCambioVigencia(item)"
          >
            power_settings_new
          </v-icon>
        </template>


        <template v-slot:item.fechaPrimerPago="{ item }">
          {{ getDateFormat(item.fechaPrimerPago) }}
        </template>

        <template v-slot:item.metricas.proximoVencimiento="{ item }">
          {{ getDateFormat(item.metricas.proximoVencimiento) }}
        </template>


        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>

        <template slot="loading">
          <div class="text-xs-center" v-t="'common.loading'"></div>
        </template>

        <template v-slot:item.action="{ item }">

          <show-button @click="$emit('show', item)"/>
          <edit-button v-if="$store.getters.hasPermission('CONVENIO_UPDATE')" @click="$emit('update', item)"/>
          <delete-button v-if="$store.getters.hasPermission('CONVENIO_DELETE')" @click="$emit('delete', item)"/>
        </template>

      </v-data-table>
    </v-col>

    <confirm-dialog
        v-if="$store.getters.hasPermission('CONVENIO_VIGENCIA')"
        v-model="dialogVigencia"
        title="Cambiar vigencia"
        description="¿Esta seguro de cambiar la vigencia del convenio?"
        @confirmed="cambiarVigencia"
    >
    </confirm-dialog>

  </v-row>
</template>

<script>
import ConvenioProvider from "../../../../providers/ConvenioProvider";

import {DeleteButton, EditButton, ShowButton, SearchInput, ConfirmDialog} from "@dracul/common-frontend"
import {DayjsMixin} from "@dracul/dayjs-frontend";
import CurrencyMixin from "@/modules/cobrox/mixins/CurrencyMixin";
import JobProvider from "@/modules/cobrox/providers/JobProvider";
import FieldSelector from "@/modules/cobrox/components/FieldSelector/FieldSelector.vue";
import dayjs from "dayjs";
import EstadoConvenioCombobox from "@/modules/cobrox/combobox/EstadoConvenioCombobox/EstadoConvenioCombobox.vue";

export default {
  name: "ConvenioList",
  components: {EstadoConvenioCombobox, FieldSelector, DeleteButton, EditButton, ShowButton, SearchInput, ConfirmDialog},
  mixins: [DayjsMixin, CurrencyMixin],
  data() {
    return {
      convenioSelected: null,
      dialogVigencia: false,
      items: [],
      totalItems: null,
      loading: false,
      orderBy: null,
      orderDesc: false,
      itemsPerPage: 5,
      pageNumber: 1,
      search: '',
      filters: [
        {
          field: 'estado',
          operator: 'in', //(eq|contain|regex|gt|lt|lte|gte)
          value: []
        }
      ],
      fields: [
          'createdAt',
        'estado',
        'fechaInactivacion',
        'cuilDeudor',
        'dniDeudor',
        'cuotas',
        'montoTotal',
        'montoCuota',
        'fechaPrimerPago',
        'fueraDePauta',
        'quitaEspecial',
        'deudas',
        'cobranzas',
        'origen',

        'metricas.pagosVencidos',
        'metricas.pagosCobrados',
        'metricas.montoVencido',
        'metricas.montoCobrado',
        'metricas.montoFaltante',
        'metricas.porcentajeVencido',
        'metricas.proximoVencimiento',
        'exito.email',
        'exito.telefono'
      ],
      fieldsSelected: [
        'createdAt',
        'metricas.proximoVencimiento',
        'estado',
        'cuilDeudor',
        'cuotas',
        'metricas.pagosCobrados',
        'montoTotal',
        'metricas.montoCobrado',
        'origen',
        // 'metricas.pagosVencidos',
        // 'metricas.montoFaltante',
        // 'metricas.montoVencido',
        // 'metricas.porcentajeVencido',
         'agencia',
        'exito.email',
        'exito.telefono'
      ],
    }
  },
  computed: {
    colorEstado(){
      return estado => {
      switch (estado) {
        case 'CANCELADO':
          return 'blue lighten-2'
        case 'VIGENTE':
          return 'green lighten-2'
        case 'POR VENCER':
          return'orange lighten-2'
        case 'CAIDO':
          return 'red lighten-2'
        case 'INACTIVO':
          return 'pink lighten-2'
        default:
          return 'grey lighten-2'
      }
      }
    },
    headersSelected() {
      return this.headers.filter(h => this.fieldsSelected.includes(h.value) || h.value === 'action')
    },
    esReactivable() {

      return convenio => {
        let fechaInactivacion = dayjs(parseInt(convenio.fechaInactivacion))
        let fechaMaximaReactivacion = fechaInactivacion.add(this.diasReactivarConvenio, 'days')
        if (dayjs().isBefore(fechaMaximaReactivacion)) {
          return true
        } else {
          return false
        }
      }

    },
    diasReactivarConvenio() {
      return this.$store.getters.getSettingValue('diasReactivarConvenio')
    },
    headers() {
      return [
        //Entity Headers
        {text: this.$t('cobrox.convenio.labels.createdAt'), value: 'createdAt'},
        {text: this.$t('cobrox.convenio.labels.proximoVencimiento'), value: 'metricas.proximoVencimiento'},
        {text: this.$t('cobrox.convenio.labels.fechaInactivacion'), value: 'fechaInactivacion'},
        {text: this.$t('cobrox.convenio.labels.estado'), value: 'estado'},
        {text: this.$t('cobrox.convenio.labels.vigente'), value: 'vigente'},
        {text: this.$t('cobrox.convenio.labels.cuilDeudor'), value: 'cuilDeudor'},
        {text: this.$t('cobrox.convenio.labels.dniDeudor'), value: 'dniDeudor'},

        {text: this.$t('cobrox.convenio.labels.cuotas'), value: 'cuotas'},
        {text: this.$t('cobrox.convenio.labels.pagosCobrados'), value: 'metricas.pagosCobrados'},
        {text: this.$t('cobrox.convenio.labels.pagosVencidos'), value: 'metricas.pagosVencidos'},


        {text: this.$t('cobrox.convenio.labels.montoTotal'), value: 'montoTotal'},
        {text: this.$t('cobrox.convenio.labels.montoCobrado'), value: 'metricas.montoCobrado'},
        {text: this.$t('cobrox.convenio.labels.montoFaltante'), value: 'metricas.montoFaltante'},
        {text: this.$t('cobrox.convenio.labels.porcentajeVencido'), value: 'metricas.porcentajeVencido'},

        {text: this.$t('cobrox.convenio.labels.montoCuota'), value: 'montoCuota'},
        {text: this.$t('cobrox.convenio.labels.fechaPrimerPago'), value: 'fechaPrimerPago'},
        {text: this.$t('cobrox.convenio.labels.fueraDePauta'), value: 'fueraDePauta'},
        {text: this.$t('cobrox.convenio.labels.quitaEspecial'), value: 'quitaEspecial'},
        {text: this.$t('cobrox.convenio.labels.deudas'), value: 'deudas'},
        {text: this.$t('cobrox.convenio.labels.cobranzas'), value: 'cobranzas'},
        {text: this.$t('cobrox.convenio.labels.origen'), value: 'origen'},
        {text: this.$t('cobrox.convenio.labels.agencia'), value: 'agencia'},
        {text: this.$t('cobrox.convenio.labels.email'), value: 'exito.email'},
        {text: this.$t('cobrox.convenio.labels.telefono'), value: 'exito.telefono'},

        //Metricas
        {text: this.$t('cobrox.convenio.labels.montoVencido'), value: 'metricas.montoVencido'},


        //Actions
        {text: this.$t('common.actions'), value: 'action', sortable: false},
      ]
    },
    getOrderBy() {
      return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
    },
    getOrderDesc() {
      return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    presentarCambioVigencia(item) {
      this.dialogVigencia = true
      this.convenioSelected = item
    },
    async cambiarVigencia() {
      await ConvenioProvider.cambiarVigenciaConvenio(this.convenioSelected.id, !this.convenioSelected.vigente)
      await this.fetch()
    },
    exportarConvenio() {
      JobProvider.exportarConvenio(this.filters, this.search, this.fieldsSelected)
          .then(resp => {
            let jobId = resp.data.exportarConvenio
            this.$router.push({name: 'JobPage', params: {id: jobId}})
          })
    },
    exportarCaidaDeCuotas() {
      JobProvider.exportarCaidaDeCuotas()
          .then(resp => {
            let jobId = resp.data.exportarCaidaDeCuotas
            this.$router.push({name: 'JobPage', params: {id: jobId}})
          })
    },
    performSearch() {
      this.pageNumber = 1
      this.fetch()
    },
    fetch() {
      this.loading = true
      ConvenioProvider.paginateConvenio(
          this.pageNumber,
          this.itemsPerPage,
          this.search,
          this.filters,
          this.getOrderBy,
          this.getOrderDesc
      ).then(r => {
        this.items = r.data.paginateConvenio.items
        this.totalItems = r.data.paginateConvenio.totalItems
      }).catch(err => {
        console.error(err)
      }).finally(() => this.loading = false)
    }
  }

}
</script>


